
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_1245_1542)"}},[_c('path',{attrs:{"d":"M30-1H0v21.818h30V-1z","fill":"#BA0C2F"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.182 7.182V-1h5.454v8.182H30v5.454H13.636v8.182H8.182v-8.182H0V7.182h8.182z","fill":"#fff"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.545 8.545V-1h2.728v9.545H30v2.728H12.273v9.545H9.545v-9.545H0V8.545h9.545z","fill":"#00205B"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_1245_1542"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h30v20H0z"}})])])])
          )
        }
      }
    